import IMAGES from './Images';

// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_CONFIG = {
  faviconUrl: process.env.PUBLIC_URL
    ? `${process.env.PUBLIC_URL}/favicon.ico`
    : '/favicon.ico',
  companyLogo: IMAGES.DOSELECT_LOGO,
  companyLogoStyle: {},
  company64x64LOGO: IMAGES.DOSELECT_MARK_LOGO,
  companyDarkLogo: IMAGES.DOSELECT_DARK_LOGO,
  companySupportEmail: 'support@doselect.com',
};
